// Shared frontend constants
export const MAX_PHOTO_SIZE_MB = 10;
export const MAX_PHOTO_SIZE_BYTES = MAX_PHOTO_SIZE_MB * 1024 * 1024;
// Resize ceiling — we downscale anything bigger client-side before upload.
// Keeps profile photos under ~400KB at decent quality without forcing the
// user to crop or re-export on their phone.
export const MAX_PHOTO_DIMENSION = 1600;
export const PHOTO_JPEG_QUALITY = 0.85;
export const MIN_AGE = 18;
export const MAX_AGE = 99;
export const MAX_INTERESTS = 8;

// Realtime timings (ms)
// How long the "typing..." indicator stays visible after the last keystroke
export const TYPING_INDICATOR_TIMEOUT_MS = 4000;
// Throttle interval between outgoing "typing" pings on the WebSocket
export const TYPING_THROTTLE_MS = 2500;
// Online users presence polling interval
export const ONLINE_POLL_INTERVAL_MS = 20000;

export const PREFERENCE_OPTIONS = [
  'Dating',
  'One Nighters',
  'Cuddling',
  'Massages',
  'Blow Job',
  'Friend with Benefits',
  'Hand Jobs',
  'Masturbation',
  'Hair Pulling',
  'Kissing',
  'Spanking',
  'Dirty Talk',
  'Hugging',
  'Nipple Play',
  'Flirting',
  'Vaginal Sex',
];

// Suggested interests used by the Browse filter (chips). Profile setup may
// allow free-text additions; the filter only surfaces these popular ones.
export const INTEREST_SUGGESTIONS = [
  'Hiking', 'Travel', 'Music', 'Cocktails', 'Movies', 'Yoga',
  'Cooking', 'Gaming', 'Art', 'Reading', 'Fitness', 'Dancing',
  'Photography', 'Coffee', 'Wine', 'Beach',
];
